export const getFilesAndDirsSelector = (state) => state.getIn(['oneDrive', 'data']);
export const isLoadingSelector = (state) => state.getIn(['oneDrive', 'isLoading']);
export const getErrorSelector = (state) => state.getIn(['oneDrive', 'error']);
